export * from './lib/app-client-shared-components-menu-content-feature.module';
